import {
	darkGrayFontColor,
	kitTintColor,
	nameCircles,
	noteTintColor,
	success,
	titles,
} from '../../../../web/styles/colors';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	accountChangeLargeTitle: {
		minWidth: 400,
		...baseStyleSheet.truncateText,
	},
	accountChangeSmallTitle: {
		width: 300,
	},
	accountChangeTitleRow: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		justifyContent: 'space-between',
		margin: '80px 0 20px',
	},
	container: {},
	dailyActiveUseSubtitle: {
		color: darkGrayFontColor,
		fontSize: 11,
		fontWeight: 'normal',
		letterSpacing: 1.1,
		marginLeft: 10,
		marginTop: 18,
		textTransform: 'uppercase',
		width: 60,
	},
	dailyUseLeft: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginRight: 30,
		width: '55%',
	},
	dailyUseRight: {
		alignItems: 'center',
		border: `1px solid ${nameCircles}`,
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		display: 'flex',
		justifyContent: 'space-between',
		minWidth: 420,
		padding: '18px 30px',
	},
	dailyUseRow: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
	},
	download: {
		color: '#006BC9',
		fontSize: 14,
		marginLeft: 6,
	},
	downloadButton: {
		alignItems: 'center',
		display: 'flex',
	},
	gray: {
		fontSize: 11,
		letterSpacing: 1.1,
	},
	green: {
		color: success,
		fontSize: 11,
		letterSpacing: 1.1,
	},
	header: {
		textAlign: 'left',
		width: 100,
	},
	newReds: {
		color: '#E30000',
		fontSize: 11,
		letterSpacing: 1.1,
	},
	orange: {
		color: kitTintColor,
		fontSize: 11,
		letterSpacing: 1.1,
	},
	percentDisplay: {
		color: darkGrayFontColor,
		fontSize: 16,
		letterSpacing: 1.6,
		textTransform: 'uppercase',
	},
	successTitleCSM: {
		minWidth: 400,
	},
	successTitleRow: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		justifyContent: 'space-between',
		margin: '30px 0 20px',
	},
	title: {
		color: titles,
		fontSize: 24,
	},
	titleIndustry: {
		color: darkGrayFontColor,
		fontSize: 11,
		fontWeight: 'normal',
		letterSpacing: 1.1,
		marginTop: 7,
		minWidth: 78,
		textTransform: 'uppercase',
	},
	titleRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '30px 0 20px',
	},
	totalIndustry: {
		color: success,
		fontSize: 24,
		fontWeight: 600,
		letterSpacing: 2.4,
		margin: '0 10px',
	},
	totalUse: {
		color: success,
		display: 'flex',
		fontSize: 56,
		fontWeight: 600,
	},
	yellow: {
		color: noteTintColor,
		fontSize: 11,
		letterSpacing: 1.1,
	},
});
